import {ResponseCache} from './response-cache';

/**
 * @type {ResponseCache<import('extensions/ui-controllers/product-list').MivaProduct[]>}
 */
const responseCache = new ResponseCache();

/**
 * @param {import('extensions/ui-controllers/product-list').MivaProduct[]} products
 * @param {boolean} cache
 * @returns {Promise<import('extensions/ui-controllers/product-list').MivaProduct[]>}
 */
export const getRuntimeProductPricing = async (products, cache = true) => {
	const body = {
		function: 'PRODUCTLIST_LOAD_PRICING',
		products
	};

	if (cache) {
		const foundJson = responseCache.get(body);

		if (foundJson) {
			return foundJson;
		}
	}

	const response = await fetch(window.mivaJS.API_Url, {
		body: JSON.stringify(body),
		headers: {
			'Content-Type': 'application/json'
		},
		method: 'POST'
	});

	if (!response.ok) {
		throw new Error('Unable to process PRODUCTLIST_LOAD_PRICING request.');
	}

	const json = await response.json();

	if (!json.success) {
		throw new Error(`${json.error_code}: ${json.message}`);
	}

	if (cache) {
		responseCache.set(body, json.data);
	}

	return json.data;
};
